export const IDLE = 'IDLE';
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const ACTIVE = 'ACTIVE';

export const colors = ['#f577cc', '#7488fe', '#b778ed', '#9ad4ce'];
